import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-x-4" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_6 = { class: "flex justify-end mt-2" }
const _hoisted_7 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, {
      style: {"height":"calc(100vh - 80px)"},
      class: "bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
          default: _withCtx(() => [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "システム設定 > 契約会社管理", -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        label: "契約会社名",
                        class: "md:w-80"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.company_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.company_name) = $event)),
                            placeholder: "契約会社名(前方一致)"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "w-24",
                        type: "primary",
                        onClick: _ctx.handleSearchButton
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("検索")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    class: "w-24",
                    type: "primary",
                    onClick: _ctx.handleAddButton
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("新規登録")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"padding-block":"0px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                data: _ctx.mTableData,
                height: 'calc(100vh - 380px)'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "編集",
                    width: "60",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Edit)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "company_code",
                    label: "契約会社ード",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "company_name",
                    label: "契約会社名",
                    width: "280"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "department_name",
                    label: "部署名",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "address",
                    label: "住所",
                    "min-width": "360"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "license_type",
                    label: "契約ライセンス種類",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "license_expiry_date",
                    label: "契約有効期限",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "60",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        link: "",
                        onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.mCurrentPage,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                "page-size": _ctx.mPageSize,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mPageSize) = $event)),
                "page-sizes": [10, 20, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.mTotalRecords,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_footer, { style: {"height":"20px"} })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '編集',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode(" 確認 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "契約会社コード",
              prop: "company_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.company_code,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.company_code) = $event)),
                  autocomplete: "off",
                  disabled: _ctx.form.add_update === 'update',
                  placeholder: "契約会社コード"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "契約会社名",
              prop: "company_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.company_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.company_name) = $event)),
                  autocomplete: "off",
                  placeholder: "契約会社名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "部署名",
              prop: "department_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.department_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.department_name) = $event)),
                  autocomplete: "off",
                  placeholder: "部署名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "住所",
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.address,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.address) = $event)),
                  autocomplete: "off",
                  placeholder: "住所"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "契約ライセンス種類",
              prop: "license_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.license_type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.license_type) = $event)),
                  autocomplete: "off",
                  placeholder: "契約ライセンス種類"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "契約有効期限",
              prop: "license_expiry_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.license_expiry_date,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.license_expiry_date) = $event)),
                  autocomplete: "off",
                  placeholder: "契約有効期限"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}